import React from "react";

export default function Day({ height }) {
  const viewBox = `0 0 5rem ${height}`;
  return (
    <svg
      width="5rem"
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M56.0748 7.36313C53.5514 9.02233 47.1963 14 40 14L40 3L58.715 3L77.4299 3C67.1068 3 59.379 5.19045 56.0748 7.36313Z"
        fill="#F2F6FB"
      />
      <path
        d="M23.9252 7.36313C26.4486 9.02233 32.8037 14 40 14L40 3L21.285 3L2.57009 3C12.8932 3 20.621 5.19044 23.9252 7.36313Z"
        fill="#F2F6FB"
      />
      <path
        d="M40.5 1C42.1569 1 43.5 2.34315 43.5 4C43.5 5.65685 42.1569 7 40.5 7C38.8431 7 37.5 5.65685 37.5 4C37.5 2.34315 38.8431 1 40.5 1Z"
        fill="#F2F6FB"
        stroke="#558CEB"
        strokeWidth="2"
      />
      <rect
        x="41"
        y="14"
        width={height}
        height="2"
        transform="rotate(90 41 14)"
        fill="#558CEB"
      />
    </svg>
  );
}
